import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'fr', 'nl', 'es', 'it'],

  // Used when no locale matches
  defaultLocale: 'fr',

  // Always use locale prefix in URLs
  localePrefix: 'always',

  // Localized pathnames configuration
  pathnames: {
    '/': '/',
    '/location/[slug]': {
      en: '/location/[slug]',
      fr: '/emplacement/[slug]',
      nl: '/locatie/[slug]',
      es: '/ubicacion/[slug]',
      it: '/posizione/[slug]'
    },
    '/summer': {
      en: '/summer',
      fr: '/ete',
      nl: '/zomer',
      es: '/verano',
      it: '/estate'
    },
    '/winter': {
      en: '/winter',
      fr: '/hiver',
      nl: '/winter',
      es: '/invierno',
      it: '/inverno'
    },
    '/mentions-legales': {
      en: '/legal-notice',
      fr: '/mentions-legales',
      nl: '/juridische-kennisgeving',
      es: '/aviso-legal',
      it: '/note-legali'
    },
    '/contact/summer': {
      en: '/7laux-rental-booking-maintenance-workshop-mtb-downhill-kids-protection',
      fr: '/7laux-location-reservation-entretien-atelier-vtt-descente-enfant-protection',
      nl: '/7laux-verhuur-boeking-onderhoud-werkplaats-mtb-downhill-kinderen-bescherming',
      es: '/7laux-alquiler-reserva-mantenimiento-taller-mtb-descenso-ninos-proteccion',
      it: '/7laux-noleggio-prenotazione-manutenzione-officina-mtb-discesa-bambini-protezione'
    },
    '/contact/winter': {
      en: '/7laux-rental-booking-maintenance-workshop-ski-snowboard-snowscoot',
      fr: '/7laux-location-reservation-entretien-atelier-ski-snowboard-snowscoot',
      nl: '/7laux-verhuur-boeking-onderhoud-werkplaats-ski-snowboard-snowscoot',
      es: '/7laux-alquiler-reserva-mantenimiento-taller-ski-snowboard-snowscoot',
      it: '/7laux-noleggio-prenotazione-manutenzione-officina-sci-snowboard-snowscoot'
    },
    '/7laux/winter': {
      en: '/7laux-ski-snowboard-ski-area-alps-families',
      fr: '/7laux-ski-snowboard-domaine-skiable-alpes-familles',
      nl: '/7laux-ski-snowboard-skigebied-alpen-gezinnen',
      es: '/7laux-esqui-snowboard-estacion-esqui-alpes-familias',
      it: '/7laux-sci-snowboard-comprensorio-sciistico-alpi-famiglie'
    },
    '/7laux/summer': {
      en: '/7laux-bike-park-mtb-enduro-downhill-ebike-alps',
      fr: '/7laux-bike-parc-vtt-enduro-descente-ebike-alpes',
      nl: '/7laux-bikepark-mtb-enduro-downhill-ebike-alpen',
      es: '/7laux-parque-bicicletas-mtb-enduro-descenso-ebike-alpes',
      it: '/7laux-bike-park-mtb-enduro-discesa-ebike-alpi'
    },
    '/location/summer': {
      en: '/7laux-mtb-rental-downhill-ebike',
      fr: '/7laux-location-vtt-descente-ebike',
      nl: '/7laux-mtb-verhuur-downhill-ebike',
      es: '/7laux-alquiler-mtb-descenso-ebike',
      it: '/7laux-noleggio-mtb-discesa-ebike'
    },
    '/location/winter': {
      en: '/7laux-ski-snowboard-rental-equipment',
      fr: '/7laux-location-ski-snowboard-equipement',
      nl: '/7laux-ski-snowboard-verhuur-uitrusting',
      es: '/7laux-alquiler-ski-snowboard-equipamiento',
      it: '/7laux-noleggio-sci-snowboard-attrezzatura'
    },
    '/atelier/summer': {
      en: '/7laux-mtb-workshop-repair-maintenance',
      fr: '/7laux-atelier-vtt-reparation-entretien',
      nl: '/7laux-mtb-werkplaats-reparatie-onderhoud',
      es: '/7laux-taller-mtb-reparacion-mantenimiento',
      it: '/7laux-officina-mtb-riparazione-manutenzione'
    },
    '/atelier/winter': {
      en: '/7laux-ski-workshop-wax-tuning',
      fr: '/7laux-atelier-ski-fartage-affutage',
      nl: '/7laux-ski-werkplaats-waxen-slijpen',
      es: '/7laux-taller-ski-encerado-afilado',
      it: '/7laux-officina-sci-sciolinatura-affilatura'
    },
    '/location-atelier/summer': {
      en: '/7laux-mtb-downhill-rental-workshop-repair-preparation',
      fr: '/7laux-location-vtt-descente-atelier-reparation-preparation',
      nl: '/7laux-mtb-downhill-verhuur-werkplaats-reparatie-voorbereiding',
      es: '/7laux-alquiler-mtb-descenso-taller-reparacion-preparacion',
      it: '/7laux-noleggio-mtb-discesa-officina-riparazione-preparazione'
    },
    '/location-atelier/winter': {
      en: '/7laux-ski-snowboard-snowscoot-rental-workshop-repair-preparation',
      fr: '/7laux-location-ski-snowboard-snowscoot-atelier-reparation-preparation',
      nl: '/7laux-ski-snowboard-snowscoot-verhuur-werkplaats-reparatie-voorbereiding',
      es: '/7laux-alquiler-ski-snowboard-snowscoot-taller-reparacion-preparacion',
      it: '/7laux-noleggio-sci-snowboard-snowscoot-officina-riparazione-preparazione'
    },
    '/blogs/winter': {
      en: '/7laux-news-ski-snowboard-snowpark-resort',
      fr: '/7laux-news-actualites-ski-snowboard-domaine-skiable',
      nl: '/7laux-nieuws-ski-snowboard-snowpark-resort',
      es: '/7laux-noticias-ski-snowboard-snowpark-resort',
      it: '/7laux-notizie-sci-snowboard-snowpark-resort'
    },
    '/blogs/summer': {
      en: '/7laux-news-mtb-enduro-downhill-trail-building-shaping',
      fr: '/7laux-news-actualites-vtt-enduro-descente-trail-building',
      nl: '/7laux-nieuws-mtb-enduro-downhill-trail-building',
      es: '/7laux-noticias-mtb-enduro-descenso-trail-building',
      it: '/7laux-notizie-mtb-enduro-discesa-trail-building'
    },
    '/blogs/winter/[slug]': {
      en: '/7laux-news-ski-snowboard-snowpark-resort/[slug]',
      fr: '/7laux-news-actualites-ski-snowboard-domaine-skiable/[slug]',
      nl: '/7laux-nieuws-ski-snowboard-snowpark-resort/[slug]',
      es: '/7laux-noticias-ski-snowboard-snowpark-resort/[slug]',
      it: '/7laux-notizie-sci-snowboard-snowpark-resort/[slug]'
    },
    '/blogs/summer/[slug]': {
      en: '/7laux-news-mtb-enduro-downhill-trail-building-shaping/[slug]',
      fr: '/7laux-news-actualites-vtt-enduro-descente-trail-building/[slug]',
      nl: '/7laux-nieuws-mtb-enduro-downhill-trail-building/[slug]',
      es: '/7laux-noticias-mtb-enduro-descenso-trail-building/[slug]',
      it: '/7laux-notizie-mtb-enduro-discesa-trail-building/[slug]'
    }
  }
});

export type Locale = (typeof routing.locales)[number];

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing); 